(function () {
  'use strict';

  if (window.__VSKLO_ANNOUNCEMENT_RUNTIME_V4__) return;
  window.__VSKLO_ANNOUNCEMENT_RUNTIME_V4__ = true;

  function initRotator(root) {
    if (!root || root.dataset.vskloAnnouncementReady === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vsklo-announcement-slide]'));
    if (!slides.length) return;

    root.dataset.vskloAnnouncementReady = 'true';

    var index = Math.max(0, slides.findIndex(function (slide) { return !slide.hidden; }));
    var timer = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var delay = Math.max(3000, Number(root.getAttribute('data-autoplay-speed') || 5) * 1000);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = 0;
    }

    function show(nextIndex) {
      var normalized = (nextIndex + slides.length) % slides.length;
      if (normalized === index) return;
      var previous = slides[index];
      var upcoming = slides[normalized];
      if (previous) previous.hidden = true;
      if (upcoming) upcoming.hidden = false;
      index = normalized;
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion || slides.length < 2 || document.hidden) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, delay);
    }

    var prev = root.querySelector('.swiper-button-prev');
    var next = root.querySelector('.swiper-button-next');

    function onPrev(event) {
      event.preventDefault();
      show(index - 1);
      start();
    }

    function onNext(event) {
      event.preventDefault();
      show(index + 1);
      start();
    }

    function onVisibility() {
      if (document.hidden) stop();
      else start();
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', onVisibility);

    root.__vskloAnnouncementCleanup = function () {
      stop();
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      root.removeEventListener('mouseenter', stop);
      root.removeEventListener('mouseleave', start);
      root.removeEventListener('focusin', stop);
      root.removeEventListener('focusout', start);
      document.removeEventListener('visibilitychange', onVisibility);
      delete root.__vskloAnnouncementCleanup;
      delete root.dataset.vskloAnnouncementReady;
    };

    start();
  }

  function initRotators(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-vsklo-announcement-rotator]')) initRotator(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-vsklo-announcement-rotator]'), initRotator);
  }

  function boot(scope) {
    initRotators(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event && event.target ? event.target : document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event && event.target;
    if (!scope) return;
    var nodes = [];
    if (scope.matches && scope.matches('[data-vsklo-announcement-rotator]')) nodes.push(scope);
    if (scope.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-vsklo-announcement-rotator]')));
    }
    nodes.forEach(function (node) {
      if (typeof node.__vskloAnnouncementCleanup === 'function') node.__vskloAnnouncementCleanup();
    });
  });
})();